export const okrPanelKebabMenuActionSelector = (state) => state.okrPanelKebabMenuActions;
